import classes from "./RoomDouble.module.css"
import arr1 from "../../../../store/arrow.png";
import logo from "../../../../store/logo.png";
import {useEffect, useState} from "react";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../../routes";

const RoomDouble = (props) => {
    const [actTime, setactTime] = useState("undefined");
    const [actDate, setactDate] = useState("undefined");

    const [loadedSlides, setloadedSlides] = useState(props.object.object);
    const [loadedSlidesDefault, setloadedSlidesDefault] = useState(props.default);
    const [meetingE, setMeetingE] = useState([]);
    const [meetingF, setMeetingF] = useState([]);

    const parseApiDate = (value) => {
        if (!value) return null;
        if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
        const raw = String(value).trim();
        if (!raw) return null;
        const clean = raw
            .replace('T', ' ')
            .replace(/\.\d+$/, '')
            .replace(/[+-]\d{2}:?\d{2}$/, '')
            .replace(/Z$/, '');
        const [datePart, timePart] = clean.split(' ');
        if (!datePart || !timePart) return null;
        const [yStr, mStr, dStr] = datePart.split('-');
        const [hStr, minStr, secStr] = timePart.split(':');
        const y = Number(yStr);
        const m = Number(mStr);
        const d = Number(dStr);
        const h = Number(hStr);
        const min = Number(minStr);
        const sec = Number(secStr || 0);
        if (![y, m, d, h, min, sec].every((n) => Number.isFinite(n))) return null;
        const parsed = new Date(y, m - 1, d, h, min, sec);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const filterActiveMeetingsNow = (rows) => {
        if (!Array.isArray(rows)) return [];
        const now = new Date();
        return rows.filter((row) => {
            const from = parseApiDate(row?.dateFrom || row?.DateFrom || row?.date_from);
            const to = parseApiDate(row?.dateTo || row?.DateTo || row?.date_to);
            // Pokud backend časy neposílá, nech záznam projít (fallback na backend filtr)
            if (!from || !to) return true;
            return from <= now && now < to;
        });
    };


    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    const sort_handler = (field) => {
        setMeetingE([]);
        setMeetingF([]);
        for (let i = 0; i < field.length; i++) {
            const desc = String(field[i].description || '');
            // Oříznout prefix "Meeting room " a pracovat jen se zbytkem (E, F, E-F, E+F, EF, ...)
            const suffixRaw = desc.length > 13 ? desc.substring(13) : desc;
            const suffix = suffixRaw.trim().toUpperCase();
            const imgUrl = assetsBaseUrl + (field[i].path || '').replace(/\\/g, '/');

            // Čisté E → levá strana
            if (suffix === 'E') {
                setMeetingE([imgUrl]);
                continue;
            }
            // Čisté F → pravá strana
            if (suffix === 'F') {
                setMeetingF([imgUrl]);
                continue;
            }
            // Skupina E-F / E+F / EF → zobrazit na PRAVÉ straně (F)
            if (suffix === 'E-F' || suffix === 'E+F' || suffix === 'EF' || /E\s*[-+]\s*F/.test(suffix)) {
                setMeetingF([imgUrl]);
                continue;
            }
        }
    }

    useEffect(() => {
        const getDefaultSlides = async () => {
            let tmpA = []
            let response = await axios.get(`${path}/getDefaultScreen`);
            //console.log(response.data)
            for (let i = 0; i < response.data.length; i++) {
                tmpA.push(assetsBaseUrl + response.data[i].path)
            }
            //console.log(tmpA)
            setloadedSlidesDefault([...tmpA])
        }

        const getRecords = async () => {
            await getDefaultSlides();
            try {
                const HOLIDAY_INN_ORG_ID = 'E15F8010-B7EB-4526-A985-F00D517EBF4C';
                const urlOrg = new URLSearchParams(window.location.search).get('orgID');
                const orgIdToUse = props.org || urlOrg || HOLIDAY_INN_ORG_ID;
                const response = await axios.get(
                    `${path}/getRecordsNowV2?orgID=${encodeURIComponent(orgIdToUse)}&day=${encodeURIComponent(getTime())}&_t=${Date.now()}`
                );
                const raw = filterActiveMeetingsNow(Array.isArray(response.data) ? response.data : []);
                // Neomezuj na cRoomGroup_id === 3 – použij všechno a nech sort_handler rozhodnout (E/F)
                const data = raw.map((item) => ({
                    description: item.room,
                    path: (item.path || '').replace(/\\/g, '/')
                }));
                if (data.length > 0) {
                    setloadedSlides(data);
                    sort_handler(data);
                } else {
                    setloadedSlides([]);
                    setMeetingE([]);
                    setMeetingF([]);
                }
            } catch (error) {
                // Na kiosk displeji je lepší vyčistit stale meeting než zobrazovat již neplatná data.
                setloadedSlides([]);
                setMeetingE([]);
                setMeetingF([]);
                console.warn('[RoomDouble] getRecords failed:', error?.message || error);
            }
        }

        const updateMinute = () => {
            let dt = new Date
            //console.log(dt)
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`)
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`)
        };

        // Nastavení intervalu pro reload meeting dat (dřív 60 s)
        const intervalId = setInterval(updateMinute, 1000);
        const intervalUpdate = setInterval(getRecords, 20 * 1000);
        // Initial load
        const list = props.object?.object;
        if (Array.isArray(list) && list.length > 0) sort_handler(list);
        getRecords();
        // Cleanup funkce, která se spustí při unmountu komponenty
        return () => {
            clearInterval(intervalId);
            clearInterval(intervalUpdate);
        };
    }, [props.org]);

    useEffect(() => {
        const resetVal = async () => {
            let rs = await axios.post(`${path}/updateReset/31`)
        }

        const getReset = async () => {
            try {
                let response = await axios.get(`${path}/getReset/31`);
                console.log(response.data[0].needUpdate);
                if (response.data[0].needUpdate === 1) {
                    // console.log("update")
                    resetVal()
                    console.log(`FE_refresh needed: ${response.data[0].needUpdate === 1 ? "YES" : "NO"}`)
                    window.location.reload();

                } else {
                    //setneedUpdate(0)
                    console.log(`FE_refresh needed: ${response.data[0].needUpdate === 1 ? "YES" : "NO"}`)
                }
            } catch (error) {

            }
        }
        const intervalId5 = setInterval(getReset, 60 * 2 * 1000);
        return () => {
            clearInterval(intervalId5);
        };
    }, []);

    let roomE = <>
        <div className={classes.header}>{"Meeting room E"}</div>
        <div className={classes.logo}>
            <img src={meetingE[0]} alt={`logo`}/>
        </div>
    </>
    let roomF = <>
        <div className={classes.header}>{"Meeting room F"}</div>
        <div className={classes.logo}>
            <img src={meetingF[0]} alt={`logo`}/>
        </div>
    </>
    let defF = <div className={classes.def}>
        <img src={loadedSlidesDefault[0]} alt={`logo`}/>
    </div>
    let defE = <div className={classes.def}>
        <img src={loadedSlidesDefault[1]} alt={`logo`}/>
    </div>

    const hasMeeting = meetingE.length > 0 || meetingF.length > 0;

    return <div className={classes.slideTot}>
        <div className={classes.box}>
            {meetingF.length != 0 && roomF}
            {meetingF.length == 0 && defF}
        </div>
        <hr className={classes.line}/>
        <div className={classes.box}>
            {meetingE.length != 0 && roomE}
            {meetingE.length == 0 && defE}
        </div>
    </div>
}

export default RoomDouble